function slideBeforeAfter(sectionId) {
  const section = document.getElementById(`section-compare-slider-${sectionId}`);
  if (!section) return;

  const input = section.querySelector('input[type="range"]');
  const handle = section.querySelector(
    ".compare-slider__handle .compare-slider__handle-line"
  );
  const before = section.querySelector(".compare-slider__image-before");
  const after = section.querySelector(".compare-slider__image-after");
  if (!input || !handle || !before || !after) return;

  const value = Number(input.value);
  const isRTL = getComputedStyle(section).direction === "rtl";

  if (isRTL) {
    before.style.clipPath = `polygon(0 0, ${100 - value}% 0, ${100 - value}% 100%, 0 100%)`;
    after.style.clipPath = `polygon(${100 - value}% 0, 100% 0, 100% 100%, ${100 - value}% 100%)`;
  } else {
    before.style.clipPath = `polygon(${value}% 0, 100% 0, 100% 100%, ${value}% 100%)`;
    after.style.clipPath = `polygon(0 0, ${value}% 0, ${value}% 100%, 0 100%)`;
  }

  handle.style.insetInlineStart = `${value}%`;
}

const initializedCompareSliders = new WeakSet();

function initializeCompareSlider(section) {
  if (initializedCompareSliders.has(section)) return;

  const input = section.querySelector('input[type="range"]');
  if (!input) return;

  initializedCompareSliders.add(section);
  const sectionId = section.dataset.id;
  const startValue = Number(input.value);
  let frameId;
  let started = false;
  let cancelled = false;

  function stopAnimation() {
    cancelled = true;
    if (frameId) cancelAnimationFrame(frameId);
  }

  input.addEventListener("pointerdown", stopAnimation);
  input.addEventListener("keydown", stopAnimation);
  input.addEventListener("input", () => {
    stopAnimation();
    slideBeforeAfter(sectionId);
  });

  slideBeforeAfter(sectionId);

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const observer = new IntersectionObserver(
    entries => {
      if (!entries[0].isIntersecting || started || cancelled) return;
      started = true;
      observer.disconnect();

      const duration = 1100;
      const distance = Math.min(16, 100 - startValue);
      const startTime = performance.now();

      function animate(now) {
        if (cancelled || !section.isConnected) return;

        const progress = Math.min((now - startTime) / duration, 1);
        const movement = Math.sin(Math.PI * progress) * distance;
        input.value = String(startValue + movement);
        slideBeforeAfter(sectionId);

        if (progress < 1) {
          frameId = requestAnimationFrame(animate);
        } else {
          input.value = String(startValue);
          slideBeforeAfter(sectionId);
        }
      }

      frameId = requestAnimationFrame(animate);
    },
    { threshold: 0.5 }
  );

  observer.observe(section);
}

document
  .querySelectorAll(".section-compare-slider")
  .forEach(initializeCompareSlider);

if (window.Shopify && Shopify.designMode) {
  document.addEventListener("shopify:section:load", event => {
    event.target
      .querySelectorAll(".section-compare-slider")
      .forEach(initializeCompareSlider);

    if (event.target.matches?.(".section-compare-slider")) {
      initializeCompareSlider(event.target);
    }
  });
}
